import React from 'react';
import { ReactSVG } from 'react-svg';
import {getBackgroundImg, getPublicImagePath, getUploadedImagePath, useAppDispatch, useAppState} from "@nutastic/nutastic-react-app";

const HomePage = () => {
    const {
        page: {
            image_1: pageImage,
            content,
            field_1: title,
            field_7,
            field_8,
            field_9,
            field_10
        }
    } = useAppState();

    const componentClass = 'home-page';
    const bannerStyle = pageImage ? getBackgroundImg(getUploadedImagePath(pageImage)) : getBackgroundImg(getPublicImagePath('homeImage.jpg'));

    return <section className={`${componentClass}__hero-banner`}>
        <div className="slideshow" style={bannerStyle} />
        <div className="hero-text">
            <h1>{ title }</h1>
            <p>{ content }</p>
            <div className="hero-buttons">
                { field_8 && field_7 && <a className="btn btn-primary" href={ field_8 }>{ field_7 }</a> }
                { field_9 && field_10 && <a className="btn btn-outline-secondary" href={ field_10 }>{ field_9 }</a> }
            </div>
        </div>
        <ReactSVG src="/public/assets/img/down-arrow.svg" className="down-arrow d-none" />
    </section>;
};

export default HomePage;
